import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Karla\",\"arguments\":[{\"display\":\"swap\",\"subsets\":[\"latin\"],\"variable\":\"--font-karla\",\"weight\":[\"500\",\"600\",\"700\",\"800\"]}],\"variableName\":\"karla\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/client-providers.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/globals.css");
